class LloginModule extends HTMLElement {
    constructor() {
        super(); // Llama al constructor de HTMLElement
    }

    connectedCallback() {
        this.load();
        this.events();
    }

    load() {
        // console.log(this);
        if (localStorage.getItem("rememberMe")) {
            let credentials = JSON.parse(
                atob(localStorage.getItem("rememberMe"))
            );
            const form = this.querySelector("form");
            form.elements.email.value = credentials.email;
            form.elements.password.value = credentials.password;
            form.elements.remember.checked = true;
        }
    }

    events() {
        this.addEventListener("click", (e) => {
            const btnEyes = e.target.closest(".toggle-password");
            if (btnEyes) {
                const iptPass = btnEyes.previousElementSibling;
                if (iptPass.type === "password") {
                    iptPass.type = "text";
                    btnEyes.innerHTML = '<i class="fa-solid fa-eye-slash"></i>'; // Revert to the eye icon when hiding password
                } else {
                    iptPass.type = "password";
                    btnEyes.innerHTML = '<i class="fa-solid fa-eye"></i>'; // Change to the eye-slash icon when showing password
                }
            }

            const ckRemember = e.target.closest("[name=remember]");
            if (ckRemember) {
                if (ckRemember?.checked) {
                    const form = this.querySelector("form");
                    const formData = new FormData(form);
                    const formObject = Object.fromEntries(formData.entries());
                    delete formObject._token;
                    if (formObject.email && formObject.password) {
                        const jsonString = JSON.stringify(formObject);
                        const encodedData = btoa(jsonString);
                        localStorage.setItem("rememberMe", encodedData);
                    }
                } else {
                    // borral localstorage
                    localStorage.clear("rememberMe");
                }
            }
        });
    }
}

customElements.define("login-module", LloginModule, { extends: "section" });
